// extracted by mini-css-extract-plugin
module.exports = {"header":"Bill_header__LXkzR","logo":"Bill_logo__2xnMF"};